export const USE_PAGINATION_API = true
export const PAGE_IMAGE = "/images/headers/khub_career.png"
export const STATE_KEY = 'careers'
export const SORT_OPTIONS = ['date'/* , 'title' */]
